import React from "react"
import Icon from "@ant-design/icons"

const HomeIconSVG = props => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5547 0.16795C7.2188 -0.0559834 6.7812 -0.0559831 6.4453 0.16795L0.748076 3.9661C-0.075161 4.51492 0.313369 5.79815 1.30278 5.79815H12.6972C13.6866 5.79815 14.0752 4.51492 13.2519 3.9661L7.5547 0.16795ZM2.00002 10.7982V5.79815H12V10.7982C12 11.3504 11.5523 11.7982 11 11.7982H3.00002C2.44773 11.7982 2.00002 11.3504 2.00002 10.7982ZM5 11.7981V9.79815C5 8.69358 5.89543 7.79815 7 7.79815C8.10457 7.79815 9 8.69358 9 9.79815V11.7981H5Z"
      fill="white"
    />
  </svg>
)

const HomeIcon = props => <Icon component={HomeIconSVG} {...props} />

export default HomeIcon
